import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { useLocalePath } from "@/hooks/useLocalePath";

export type LocalizedLinkProps = Omit<LinkProps, "to"> & {
  to: string;
};

/**
 * Drop-in replacement for react-router's <Link>.
 * Automatically prepends the current language prefix to the `to` prop.
 */
const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  ({ to, ...props }, ref) => {
    const { localePath } = useLocalePath();

    // Handle hash-only or external links
    const href =
      to.startsWith("#") || to.startsWith("http") ? to : localePath(to);

    return <Link ref={ref} to={href} {...props} />;
  },
);

LocalizedLink.displayName = "LocalizedLink";

export { LocalizedLink };
export default LocalizedLink;
